import AppTranslation, { AppTranslationMessage } from "../../../app/AppTranslation";
import Images from "../../../assets/images";

enum StvKampagne {
    AKTION_1_HUND = "AKTION_1_HUND",
    AKTION_2_HUNDEHALSBAND = "AKTION_2_HUNDEHALSBAND"
}

export default StvKampagne;

// Kamagne Images
const IMAGE_MAP = new Map();
IMAGE_MAP.set(StvKampagne.AKTION_1_HUND, Images.kampagne1Hund);
IMAGE_MAP.set(StvKampagne.AKTION_2_HUNDEHALSBAND, Images.kampagne2Hundehalsband);

export function getKampagneImage(value: StvKampagne) {
    if (value && IMAGE_MAP.has(value)) {
        return IMAGE_MAP.get(value);
    }

    return undefined;
}

export function getKampagneText(value: StvKampagne) {
    if (!value) {
        return undefined;
    }

    return AppTranslation.getMessage(AppTranslationMessage.APP_KAMPAGNE_TEXT, value);

}